import axios from 'axios';

const AXIOS = axios.create({
    baseURL:`http://vienna.axonivy.com/primeSKN/primeSKN/api`
})

export default {

  createWFMSTask(data, url) {
    const AXIOS = axios.create({
      baseURL: url
    })
  
    return AXIOS.post("/motiverse/survey", data, {
        headers:{
            "X-Requested-By":"Motiverse"
        }
    });
  }
}